module.exports = __webpack_public_path__ + "static/media/badge-0.43aa9303.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badge-0.png
// module id = 1618
// module chunks = 1